import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import AlertMessage from "../../components/AlertMessage";
import { generateTicket,uploadImage } from "../../api/apiService";
import { useToken } from "../../components/TokenContext";

const CreateTicket = () => {

  const [images, setImages] = useState([]);
  const [dragOver, setDragOver] = useState(false);
  const [subject, setSubject] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [categoryText, setCategoryText] = useState("");
  const [message, setMessage] = useState("");
  
  const [reactalert, setAlert] = useState({ type: "", message: "" }); 
  const { token, fetchToken } = useToken();

  useEffect(() => {
    const initialize = async () => {
      try {
        if (!token) {
            await fetchToken(); // Wait for token fetch
          }
        } 
        catch (err) {
          console.error(err);
        }
      };
      initialize();
  }, [token, fetchToken]);

  // File Selection + Preview + Upload
  const handleFileChange = async (files) => {
    const newFiles = Array.from(files);
    for (let file of newFiles) {
      try {
        const previewUrl = URL.createObjectURL(file); // Local Preview
        // Call upload API (Pass Token + File)
        // Make Sure We Have Token
        let currentToken = token;
        if (!currentToken) {
          currentToken = await fetchToken();
          if (!currentToken) return;
        }
        const result = await uploadImage(currentToken, file);
        if (result?.status) {
          // Use The Returned File URL From API
          setImages((prev) => [
            ...prev,
            { preview: previewUrl, url: result.data }, 
          ]);
        } else {
          console.error("Upload failed:", result?.error || result?.message);
        }
      } catch (err) {
        console.error("File upload error:", err);
      }
    }
  };

  // Drag & Drop Events
  const handleDragOver = (e) => {
    e.preventDefault();
    setDragOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    handleFileChange(e.dataTransfer.files);
  };

  const removeImage = (index) => {
    setImages(images.filter((_, i) => i !== index));
  };

  const handleCategoryChange = (e) => {
    const selectedValue = e.target.value;
    const selectedText = e.target.options[e.target.selectedIndex].text;
    setCategoryId(selectedValue);
    setCategoryText(selectedText);
  };

  const handleSubmit = async (e) => {
       e.preventDefault();
       // Make Sure We Have Token
       let currentToken = token;
       if (!currentToken) {
         currentToken = await fetchToken();
         if (!currentToken) return;
       }
       try {
         const loginToken = localStorage.getItem("LoginToken"); // <-- login token
         if (!loginToken) {
          setAlert({ type: "error", message: "Session Expired Please Login Again." });
          return;
         }
         const data = await generateTicket(currentToken,loginToken,categoryId,categoryText,subject,message,images.map((img) => img.url).join(","));
         if (data?.status && data?.data === "success") {
            setAlert({ type: "success", message: "Ticket Submitted Successfully !" });
         } 
         else {  
           setAlert({ type: "error", message: data?.data || "Ticket Submission Failed !" });
         }
       } 
       catch (err) {
         setAlert({ type: "error", message: "Something went wrong while Ticket Submiting." });
       }    
  };

  return (
    <div className="row">
      <div className="col-md-6">
        <div className="buyshheikh-page">
          <div className="pageTitle d-flex justify-content-between align-items">
            <span>🎫 Create Support Ticket </span>
            <a href="#" className="capping-color">
              <i className="fa-solid fa-clock-rotate-left"></i>
            </a>
          </div>
          <div className="card mb-3">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                {/* Subject */}
                <div className="mb-3">
                  <label className="form-label fw-semibold">
                    Subject <sup className="capping-color">*</sup>
                  </label>
                  <input
                    type="text"
                    name="subject"
                    className="form-control form-control-new modern-input"
                    placeholder="Enter subject"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    required
                  />
                </div>

                {/* Category */}
                <div className="mb-3">
                  <label className="form-label fw-semibold">
                    Category <sup className="capping-color">*</sup>
                  </label>
                  <select
                    name="category"
                    className="form-control form-control-new modern-input"
                    value={categoryId}
                    onChange={handleCategoryChange}
                    required
                  >
                    <option value="0">Select Category</option>
                    <option value="1">Complaint</option>
                    <option value="2">Support</option>
                    <option value="3">Training</option>
                  </select>
                </div>

                {/* Message */}
                <div className="mb-3">
                  <label className="form-label fw-semibold">
                    Message <sup className="capping-color">*</sup>
                  </label>
                  <textarea
                    name="message"
                    className="form-control form-control-new modern-input"
                    rows="4"
                    placeholder="Enter your message..."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                  ></textarea>
                </div>

                {/* File Upload with Drag & Drop */}
                <div className="mb-3">
                  <label className="form-label fw-semibold">Attach Images </label>

                  <div
                    className={`upload-dropzone ${dragOver ? "drag-over" : ""}`}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                  >
                    <input
                      type="file"
                      id="fileUpload"
                      multiple
                      accept="image/*"
                      onChange={(e) => handleFileChange(e.target.files)}
                      className="d-none"
                    />
                    <label htmlFor="fileUpload" className="upload-btn">
                      <i className="fa fa-cloud-upload-alt me-2"></i>
                      Click to choose or Drag & Drop files here
                    </label>
                  </div>

                  {/* Preview Grid */}
                  <div className="image-preview-grid mt-3">
                    {images.map((img, index) => (
                      <div key={index} className="preview-card">
                        <img src={img.preview} alt="preview" />
                        <button
                          type="button"
                          className="remove-btn"
                          onClick={() => removeImage(index)}
                          >
                          <i className="fa fa-times"></i>
                        </button>
                      </div>
                    ))}
                  </div>
                </div>

                {reactalert.message && (
                  <AlertMessage
                    type={reactalert.type}
                    message={reactalert.message}
                    onClose={() => setAlert({ type: "", message: "" })}
                  />
                )}

                {/* Submit */}
                <div className="">
                  <button type="submit" className="btn btn-warning">
                    Submit Ticket 🚀
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateTicket;
